module.exports = __webpack_public_path__ + "static/media/issue-icon.198679b5.svg";